var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.012,12.46,23.988,7,24,18.213,13,24ZM.487,18.475A.926.926,0,0,1,0,17.661V7l4.451,2.21V13.1a.891.891,0,1,0,1.781,0V10.109l.593.292L11,12.476,10.988,24Zm7.12-9.54L7,8.627,18.019,3l.607.307L23,5.458,11.8,11ZM1,5.013,11.544.086a.9.9,0,0,1,.769,0L16,1.8,5.267,7Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShipping);
export default __webpack_public_path__ + "static/media/icon-shipping.6975685b83c90d11667178b28a86d653.svg";
export { ForwardRef as ReactComponent };